// Fiche produit — disposition "galerie + vignettes verticales + colonne
// d'achat" (réglage de section pdp_layout = respire).
//
// Aucune logique de panier, de variante ni de galerie n'est dupliquée ici :
// product-info.js, product-form.js et media-gallery.js restent seuls maîtres
// du formulaire natif. Ce script ne fait que deux compléments d'affichage :
//
// 1) Prix du bouton "Ajouter au panier" : product-info.js publie déjà, à
//    chaque changement de variante, le HTML de la section re-rendue par
//    Shopify (évènement PUB_SUB_EVENTS.variantChange). On y relit le prix
//    calculé côté serveur (#AtcPrice-<section>) et on le recopie tel quel —
//    même source que le reste de la fiche, aucun calcul de prix en JS.
//
// 2) Colonne de vignettes verticale (ordinateur) : media-gallery.js fait
//    défiler la liste de vignettes horizontalement uniquement. Quand la
//    vignette active change (clic, flèches, variante), on la ramène dans la
//    partie visible de la colonne si elle en sort.
(function () {
  if (window.__pdpRespireInit) return;
  window.__pdpRespireInit = true;

  function syncAtcPrice(sectionId, html) {
    if (!sectionId || !html) return;
    var source = html.getElementById('AtcPrice-' + sectionId);
    var destination = document.getElementById('AtcPrice-' + sectionId);
    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  // PUB_SUB_EVENTS est déclaré en "const" (constants.js) : il n'est pas une
  // propriété de window, d'où le test typeof.
  function subscribeToVariantChange() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data) return;
      syncAtcPrice(data.sectionId, data.html);
    });
  }

  function keepThumbnailVisible(item) {
    var list = item && item.parentElement;
    if (!list || list.scrollHeight <= list.clientHeight + 1) return;
    // Colonne verticale uniquement : en bande horizontale (mobile/tablette),
    // media-gallery.js gère déjà le défilement.
    if (getComputedStyle(list).flexDirection !== 'column') return;

    var top = item.offsetTop;
    var bottom = top + item.offsetHeight;
    var margin = 8;
    var target = null;

    if (top < list.scrollTop + margin) {
      target = top - margin;
    } else if (bottom > list.scrollTop + list.clientHeight - margin) {
      target = bottom - list.clientHeight + margin;
    }
    if (target === null) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    list.scrollTo({ top: Math.max(0, target), behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  function watchThumbnails(list) {
    if (!list || list.dataset.pdpRespireWatched) return;
    list.dataset.pdpRespireWatched = 'true';

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var button = mutation.target;
        if (button.hasAttribute && button.hasAttribute('aria-current')) {
          keepThumbnailVisible(button.closest('.thumbnail-list__item'));
        }
      });
    }).observe(list, { attributes: true, subtree: true, attributeFilter: ['aria-current'] });
  }

  function init() {
    subscribeToVariantChange();
    document.querySelectorAll('.product--respire .thumbnail-list').forEach(watchThumbnails);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
